import React from "react";
import { GiftIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/bonuses";
export function Bonuses() {
  return <Section className="bg-lilac-soft" data-id="element-109" data-mp="1clzecp0u5062">
      <SectionHeading eyebrow="Included free with your purchase" title="Your five exclusive pediatric articulation bonuses" intro="Five additional resources to complement your six-volume collection." data-id="element-110" data-mp="1citkkwh9ha40" />

      <div className="mt-12 space-y-10 md:space-y-16" data-id="element-111" data-mp="20ail3048l4w1">
        {bonuses.map((b, i) => <article key={b.n} className="-mx-4 overflow-hidden bg-white sm:mx-0 sm:rounded-[32px] sm:shadow-[0_16px_40px_rgba(15,37,87,0.08)] md:grid md:grid-cols-2 md:items-center" data-id="element-112" data-mp="1w8nkjxu4qvjb" data-mpi={i}>
            <div className={i % 2 === 1 ? "md:order-2" : ""} data-id="element-113" data-mp="kv1l9juk3dk2">
              <img src={b.image} alt={`Bonus ${b.n}: ${b.title}`} className="h-auto w-full" loading="lazy" data-id="element-114" data-mp="fux55uxk8kud" />
            </div>
            <div className="px-5 pb-8 pt-2 sm:px-8 md:py-10" data-id="element-115" data-mp="1etexke1wu2aj">
              <span className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 font-display text-sm font-bold uppercase tracking-wide ${b.badge}`} data-id="element-116" data-mp="1eru5qw6zcxgd">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-117" data-mp="15s70u0f1l9ik" />
                Bonus #{b.n}
              </span>
              <h3 className="mt-3 font-display text-[28px] font-bold leading-tight text-navy" data-id="element-118" data-mp="1aq8kamgdrauk">{b.title}</h3>
              <p className="mt-2 font-display text-lg font-semibold text-coral" data-id="element-119" data-mp="w12lgzlgfmn7">{b.tagline}</p>
              <div className="mt-3 space-y-3 text-[16px] leading-relaxed text-ink/80" data-id="element-120" data-mp="10v6xhx9kukv5">
                {b.body.map(p => <p key={p} data-id="element-121" data-mp="r42hcu860tyq">{p}</p>)}
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl bg-mint-soft px-4 py-3" data-id="element-122" data-mp="r1zrca70j0u0">
                <span className="text-[15px] font-bold text-ink/70" data-id="element-123" data-mp="d6e3w7gfgp3p">
                  Reference value: <span className="line-through" data-id="element-124" data-mp="i2med7joju4j">${b.value}</span>
                </span>
                <span className="font-display text-base font-bold uppercase text-mint" data-id="element-125" data-mp="2ju4qc7w4p0g9">Included with your purchase</span>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-12" data-id="element-126" data-mp="2b0ro2fc6cmhi">
        <CTAButton label="Yes! Give me all five bonuses" data-id="element-127" data-mp="2axvpqpwezvsj" />
      </div>
    </Section>;
}